<template>
  <div>
    <nav v-if="breadcrumb" class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'bandwidth_policies'}">Bandwidth policies</router-link>
            <span class="mx-2">/</span>
            <div>{{ bandwidthPolicy.name }}</div>
          </div>
          <div class="text-xl text-primary">
            {{ bandwidthPolicy.name }}
          </div>
        </div>
        <div class="">
          <div class="inline-block relative float-right">
            <button @click="deletePolicy" style="color: white !important;"
                    class="bg-red-500 text-white hover:bg-teal-700 py-2 px-4 rounded-sm inline-flex items-center">
              Delete
            </button>
          </div>
        </div>
      </div>
    </nav>
    <div class="py-4 md:px-0 px-2">
      <div class="md:flex block">
        <div class="w-full rounded-lg  overflow-hidden  md:max-w-xs mb-3">
          <div class=" bg-white rounded-lg border shadow-sm">
            <div class="text-center px-3 pb-6 pt-2">
              <h3 class="text-black text-sm bold font-sans">{{ bandwidthPolicy.name || '' }}</h3>
              <p class="mt-2 font-sans font-light text-grey-dark">Down link:
                {{ bandwidthPolicy.max_download + '' + bandwidthPolicy.max_download_unit }}</p>
              <p class="mt-2 font-sans font-light text-grey-dark">Up link:
                {{ bandwidthPolicy.max_upload + '' + bandwidthPolicy.max_upload_unit }}</p>
            </div>

            <ul class="mt-2 flex flex-wrap md:block">
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'bandwidth_policy', params: {id: policyId, path:'details'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="edit" size="16" class="mr-4"/>
                  Update
                </router-link>
              </li>

              <li class="border-l-4 border-transparent  hover:border-teal-700 my-2 ">
                <div @click="deletePolicy"  v-if="$store.getters.can('delete_bandwidth_policy')"
                     class="block items-center flex lg:mt-0 px-3 h-8 text-red-500 hover:text-teal-700">
                  <feather type="trash" size="16" class="mr-4"/>
                  Delete
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="w-full mt-3 md:mt-0 md:mx-4 ">
          <CreateBandwidthPolicy :policy-id="policyId" :breadcrumb="false"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";
import CreateBandwidthPolicy from "@/modules/bandwidthPolicy/CreateBandwidthPolicy";

export default {
  name: "BandwidthPolicy",
  components: {CreateBandwidthPolicy},
  data() {
    return {
      bandwidthPolicy: Object
    }
  },
  props: {
    policyId: String,
    path: String,
    breadcrumb: {default: true, type: Boolean}
  },
  mounted() {
    this.queryPolicy();
  },

  methods: {
    queryPolicy() {
      GraphQl.sendRequest('{bandwidthPolicy(id: "' + this.policyId + '"){id name max_download max_download_unit max_upload max_upload_unit description}}')
          .then(response => {
            this.bandwidthPolicy = response.bandwidthPolicy;
          })
    },
    deletePolicy() {
      let delConfirm = confirm("Are you sure you want to delete this policy?")
      if (delConfirm)
        GraphQl.sendRequest('mutation{deleteBandwidthPolicy(id: "' + this.policyId + '"){code message}}')
            .then(response => {
              alert(response.deleteBandwidthPolicy.message);
              this.$router.push({message: 'bandwidth_policies'})
              // this.$root.$emit('alert_success', [response.deleteBandwidthPolicy.message]);
              // setTimeout(() => {
              //   this.$router.push({name: 'bandwidth_policies'})
              // }, 3000)

            })
    }
  }
}
</script>

<style scoped>

</style>